module.exports = __webpack_public_path__ + "img/ai-radio-active.9fe986f0.png";